import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createHeaderFooterSettingsApi, headerFooterSettingsApiRelativePath } from './index';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
export var createHeaderFooterSettingsApiApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createHeaderFooterSettingsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetHeaderFooterSettings: function (dto) {
            return createFakeGetResponder(fakeHttp, headerFooterSettingsApiRelativePath + "/" + dto.locale);
        },
        whenUpdateHeaderFooterSettings: function (dto) {
            return createFakePutResponder(fakeHttp, headerFooterSettingsApiRelativePath + "/" + dto.locale)(dto.data);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map